import React from 'react';
import { Modal, Input } from 'antd';
import { ExclamationCircleOutlined, MailOutlined } from '@ant-design/icons';
import { InvoiceProps } from 'models/Invoice';
import { editCustomer, getCustomer } from 'services/Customers';
import { mailInvoice } from './Mail';
import { CustomerProps } from 'models/Customer';
import { EventEmitter } from './EventEmitter';
import { EVENTS } from '~/enums/common';

export const mailConfirm = (invoice: InvoiceProps) => {
  let input: Input | null = null;

  Modal.confirm({
    title: 'Please specify customer email',
    icon: <ExclamationCircleOutlined />,
    content: (
      <Input
        ref={(ref) => {
          input = ref;

          if (ref) {
            setTimeout(() => ref.focus(), 150);
          }
        }}
        placeholder="Customer Email"
        prefix={<MailOutlined />}
      />
    ),
    async onOk() {
      if (input) {
        const email = input.input.value;

        if (!email) {
          return;
        }

        if (invoice.customer.customerId) {
          try {
            const response = await getCustomer(invoice.accountId, invoice.customer.customerId);
            const responseCustomer: CustomerProps = response.data.data;

            await editCustomer(invoice.accountId, invoice.customer.customerId, {
              name: responseCustomer.name,
              email: email,
              phoneNumber: responseCustomer.phoneNumber || '',
              notes: responseCustomer.notes
            });

            invoice.customer.email = email;

            EventEmitter.trigger(EVENTS.CUSTOMER_UPDATED);
          } catch (e) {
            return false;
          }
        }

        await mailInvoice(invoice);

        return true;
      }

      return false;
    }
  });
};

export const mailEnsure = (invoice: InvoiceProps) => {
  Modal.confirm({
    title: 'Please Confirm',
    icon: <ExclamationCircleOutlined />,
    content: `The email will be sent to ${invoice.customer.name} (${invoice.customer.email}). Would you like to proceed?`,
    async onOk() {
      await mailInvoice(invoice);

      return true;
    }
  });
}